module.exports = __webpack_public_path__ + "static/media/nexalyn-pumpup-package.4eb14440.png";